<div class="PGResourceViewCalendarConfig">
    <div class="container-fluid">
        @if (noDateFields) {
            <div class="row">
                <div class="col">Nessun campo data presente nella risorsa</div>
            </div>
        }
        @if (!noDateFields) {
            <div class="row">
                <label class="col-2">
                    dateField
                </label>
                <div class="col">
                    <app-pg-select [options]="viewDateOptions" [(ngModel)]="view.config.dateField" display="oneLine" [required]="true"></app-pg-select>
                </div>
            </div>
        }
    </div>
</div>

